import { useQuery } from '@tanstack/react-query';
import { queryKeys, type DashboardPeriod } from '../../shared/data/queryKeys';
import { getDashboardStats } from './api';

export function useDashboardStats(period: DashboardPeriod) {
  return useQuery({
    queryKey: queryKeys.dashboardStats(period),
    queryFn: () => getDashboardStats(period),
  });
}
